<template>
  <div id="alertStickyBar" v-if="stickyData && showStickyData">
    <p class="title">
      <i class="icon icon--warning-red-size20"></i>
      <strong>{{ stickyData.title }}</strong>
    </p>
    <p v-if="stickyData.description" class="desc">{{ stickyData.description }}</p>
    <div v-if="stickyData.buttonText" class="button--wrap">
      <ui-button class="btn__subscribe" :primary="true" @click="onActionClick">
        {{ stickyData.buttonText }}
      </ui-button>
      <ui-button class="btn__close" :primary3="true" @click="onCloseLayer">
        {{ $t('common.close') }}
      </ui-button>
    </div>
    <i class="icon icon--close-size26" @click="onCloseLayer"></i>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { openContactUs } from '@/libs/utils'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    UiButton
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showStickyData'
    ]),
    stickyData () {
      return this.planData ? this.planData.stickyData : null
    }
  },
  methods: {
    ...mapMutations([
      'setShowStickyData'
    ]),
    onCloseLayer () {
      this.setShowStickyData(false)
    },
    onActionClick () {
      this.onCloseLayer()

      switch (this.stickyData.action) {
        case 'cancelPlanChange':
        case 'withdrawPlanCancellation':
        case 'createPlan':
        case 'changePlan':
          this.$router.push({
            name: 'managePlan',
            params: { action: this.stickyData.action },
            query: { ts: new Date().getTime() }
          })
          break
        case 'contactUs':
          let form = ''
          if (this.planData.applyType === 'admin') {
            form = this.$t('plan.contactForm')
            openContactUs(this.userData.userNum, form, true)
          } else {
            openContactUs(this.userData.userNum)
          }
          break
        case 'goBilling':
          this.$router.push({ name: 'billing' })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
#alertStickyBar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000010;
  width: 100%;
  min-width: 1024px;
  height: 157px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 11px 23px 0 rgba(0, 0, 0, 0.33);
  background-color: #1b1b1b;
  padding-top: 20px;
  padding-left: 60px;
  padding-right: 66px;
  box-sizing: border-box;

  .title {
    position: relative;
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    padding-bottom: 3px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    .icon {
      position: absolute;
      top: 50%;
      right: calc(100% + 10px);
      transform: translateY(-50%);
    }
  }

  .desc {
    font-size: 16px;
    color: #c1c1c1;
    margin-top: 6px;
    padding-bottom: 3px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .button--wrap {
    margin-top: 20px;

    .btn__close {
      margin-left: 5px;
    }
  }

  .icon--close-size26 {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}
</style>
